import { getToken, onMessage } from "firebase/messaging";
import { apiClient } from "../Lib/Config/api.config";
import {
  isMessgingSupported,
  messaging,
  messagingKey,
} from "../Lib/Config/firebase.config";
import { NETWORK_ERROR } from "../Lib/Consts";
import AuthController from "./AuthController";

class NotificationController {
  static isNotification = false;
  static NotificationPromise = null; // To store the pending promise

  static getFcmToken(_callback = () => false) {
    return new Promise((resolve, reject) => {
      if (!isMessgingSupported) {
        reject("Notification unsupported!");
        return;
      }
      Notification.requestPermission()
        .then((res) => {
          if (res === "granted" && messaging) {
            getToken(messaging, { vapidKey: messagingKey })
              .then((token) => {
                console.log(token, "@token  .!");
                _callback(token);
                resolve(token);
              })
              .catch((err) => {
                _callback(false);
                console.log(err, "@token  error.!");
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log("@notification err...", err);
          reject("Notification permission blocked!");
        });
    });
  }
  static saveFcmToken(token) {
    console.log("@save token ....", token);
    return new Promise((resolve, reject) => {
      apiClient
        .post("/api/admin/add-notification-token", {
          token,
        })
        .then((res) => {
          console.log("@save token res...", res?.data);
          if (res?.data?.success) {
            resolve(res?.data?.data);
            let session = AuthController.getPersistedCredentials();
            session = {
              ...session,
              fcm_token: token,
            };
            AuthController.persistCredentials(session);
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@save token err...", err?.response?.data);
          reject(err?.response?.data);
        });
    });
  }
  static removeFcmToken(token, id) {
    // Check if an API call is already in progress
    if (NotificationController.isNotification) {
      return NotificationController.NotificationPromise;
    }

    // Set the flag to indicate that the API call is in progress
    NotificationController.isNotification = true;
    const data = {
      token: token,
    };
    // Create a new promise and store it
    NotificationController.NotificationPromise = new Promise(
      (resolve, reject) => {
        apiClient({
          url: `/api/admin/remove-notification-token/${id}`,
          method: "POST",
          data,
        })
          .then((res) => {
            console.log("@delete fcm token...", res?.data);
            if (res?.data?.success) {
              resolve(res?.data?.data);
            } else {
              reject(res?.data);
            }
          })
          .catch((err) => {
            console.log("@delete token err...", err?.response?.data);
            reject(err?.response?.data);
          });
      }
    );

    return NotificationController.NotificationPromise;
  }

  // static removeFcmToken(token) {
  //   const data = {
  //     token: token,
  //   };
  //   console.log(data, "@delete token");
  //   return new Promise((resolve, reject) => {
  //     apiClient({
  //       url: "/api/admin/remove-notification-token",
  //       method: "POST",
  //       data,
  //     })
  //       .then((res) => {
  //         console.log("@delete fcm token...", res?.data);
  //         if (res?.data?.success) {
  //           resolve(res?.data?.data);
  //         } else {
  //           reject(res?.data);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("@delete token err...", err?.response?.data);
  //         reject(err?.response?.data);
  //       });
  //   });
  // }

  static onNotification() {
    if (!isMessgingSupported) {
      return;
    }
    onMessage(messaging, (payload) => {
      console.log(payload, "@notification.!");
      NotificationController.get();
      // ToastController.success(payload?.notification?.title);
      alert("Notification arrived");
      new Notification(
        payload?.notification?.title,
        payload?.notification?.body
      );
    });
  }

  static get() {
    return new Promise((resolve, reject) => {
      apiClient({
        url: `/api/admin/get-notifications`,
        method: "GET",
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }
  static readNotification(data = { updateAll: false, notificationId: null }) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: `/api/admin/update-notifications`,
        method: "POST",
        data,
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }
}

export default NotificationController;
